import { RoleFormMessages, TranslationRoleFormMessages } from "@languages/interfaces";

export const messages: TranslationRoleFormMessages = {
  [RoleFormMessages.fieldName]: "Nome",
  [RoleFormMessages.fieldDescription]: "Descrição",
  [RoleFormMessages.createRole]: "Criar grupo",
  [RoleFormMessages.editRole]: "Editar grupo",
  [RoleFormMessages.deleteRole]: "Apagar grupo",
  [RoleFormMessages.confirmDeleteTitle]: "Confirmação de exclusão",
  [RoleFormMessages.confirmDeleteMessage]: "Tem certeza que deseja excluir este grupo?"
};